import { isly } from "isly";
import { Alpha2 as CountryCodeAlpha2 } from "./Alpha2";
import { Alpha3 as CountryCodeAlpha3 } from "./Alpha3";
import { Name as CountryCodeName } from "./Name";
import { Numeric as CountryCodeNumeric } from "./Numeric";
export var CountryCode;
(function (CountryCode) {
    var _a;
    CountryCode.Alpha2 = CountryCodeAlpha2;
    CountryCode.Alpha3 = CountryCodeAlpha3;
    CountryCode.Name = CountryCodeName;
    CountryCode.Numeric = CountryCodeNumeric;
    _a = isly
        .union(CountryCode.Alpha2.type, CountryCode.Alpha3.type, CountryCode.Numeric.type)
        .rename("isoly.CountryCode")
        .bind(), CountryCode.type = _a.type, CountryCode.is = _a.is, CountryCode.flawed = _a.flawed;
})(CountryCode || (CountryCode = {}));
//# sourceMappingURL=index.js.map